var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"background-color":"orange","dark":""}},[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$router.replace('/privacypolicy')}}},[_vm._v("Integritetspolicy")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }